import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
const PAY_TYPE = {
    coin: '藤币支付',
    wechat: '微信支付',
    gold: '金币支付',
    alipay: '支付宝',
    alipay_hb: '花呗分期',
    alipay_pcredit: '花呗',
};
let Address = class Address extends Vue {
    constructor() {
        super(...arguments);
        this.payType = '';
        this.isTicket = false;
        this.filterPayList = [];
        this.currentPayType = 'wechat';
        this.active = 3;
        this.hbfqList = [];
    }
    get payName() {
        return PAY_TYPE[this.payType] || '微信支付';
    }
    get payIcon() {
        return PAY_TYPE[this.payType + '_icon'] || '';
    }
    // 支付金额小于1000时，过滤花呗分期
    payAmountChange(newV) {
        if (+newV === 0) {
            this.hbfqList = [];
        }
        else {
            this.hbfqList = [
                {
                    stage: 3,
                    price: (newV / 3).toFixed(5).replace(/(\d*)\.(\d{2}).*/, `$1.$2`),
                },
                {
                    stage: 6,
                    price: (newV / 6).toFixed(5).replace(/(\d*)\.(\d{2}).*/, `$1.$2`),
                },
                {
                    stage: 12,
                    price: (newV / 12).toFixed(5).replace(/(\d*)\.(\d{2}).*/, `$1.$2`),
                },
            ];
        }
    }
    created() {
        let { pt = 'wechat', from } = this.$route.query;
        this.payType = pt;
        this.isTicket = from === 'ticket';
        this.filterPayList = this.payList;
    }
    checkFq(item) {
        this.active = item.stage;
        this.$emit('pay-fq-info', item);
    }
    checkedItem(data) {
        // this.$set(item, 'checked', !item.checked)
        this.currentPayType = data.pay_type;
        this.$emit('pay-type-changed', data.pay_type);
        if (data.pay_type === 'alipay_hb') {
            this.checkFq(this.hbfqList[0] || {});
        }
        // this.filterPayList = this.filterPayList.map(item => {
        //   if (item.pay_type === data.pay_type) {
        //     item.checked = true
        //   } else {
        //     item.checked = false
        //   }
        //   return item
        // })
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], Address.prototype, "coinAccount", void 0);
tslib_1.__decorate([
    Prop()
], Address.prototype, "realPrice", void 0);
tslib_1.__decorate([
    Prop()
], Address.prototype, "payList", void 0);
tslib_1.__decorate([
    Prop()
], Address.prototype, "payAmount", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], Address.prototype, "classes", void 0);
tslib_1.__decorate([
    Watch('realPrice', { immediate: true })
], Address.prototype, "payAmountChange", null);
Address = tslib_1.__decorate([
    Component
], Address);
export default Address;
